<template>
  <div class="content" align="center">
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  created() {
    if (localStorage.getItem("token")) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    }
  },
  mounted() {},
};
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  margin: 0px;
}
body,
html {
  background-color: #f5f5f5;
  margin: 0px;
  height: 100%;
  /*font-family: "Times New Roman";*/
}
div,
span,
label,
a,
h1,
h2,
h3,
input,
textarea {
  font-family: Helvetica, Arial, sans-serif;
}
.imgback {
color:#666;
margin-left:0px;
margin-right: 10px;
margin-top:2px;
}
.imgback:hover {
color:rgb(38, 197, 62);
cursor: pointer;
}
.btns {
  background: none;
  background-color: #0b76ef;
  padding: 14px 12px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
}
.btns:hover {
  background-color: #1381fd;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0);
  cursor: pointer;
}
.btnss {
  background: none;
  background-color: #4caf50;
  padding: 12px 12px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  color: #ffffff;
}
.btnss:hover {
  background-color: #309533;
  cursor: pointer;
}
a {
  text-decoration: none;
}
.btnb {
  background: none;
  background-color: #ef9f0b;
  padding: 14px 12px;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
}
.btnb:hover {
  background-color: #e7b615;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0);
  cursor: pointer;
}
.btnnoback {
  background: none;
  padding: 10px;
  border: none;
  color: #0b76ef;
}
.btnnoback:hover {
  cursor: pointer;
}
 .avto {
  color:rgb(83, 83, 83);
  margin:3px 3px 0px 1px;
}
 .moto {
  color:#754ba9;
  margin:3px 3px 0px 1px;
}
 .gruzspes {
  color:rgb(211, 187, 52);
  margin:3px 3px 0px 1px;
}
 .zapak {
  color:rgb(91, 91, 88);
  margin:3px 3px 0px 1px;
}
.drugoyt {
  color:rgb(57, 158, 189);
  margin:3px 3px 0px 1px;

}
 .remus {
  color:rgb(59, 185, 97);
  margin:3px 3px 0px 1px;
}
.font_20 {
  font-size: 20px;
}
.spin {
  width:100%;
  height: 70px;
  background-color: #f5f5f5;
  margin-left: -10px;
  padding: 0px 10px 0px 10px;
}
.font_22 {
  font-size: 22px;
}

.margin_5 {
  margin-left: 5px;
}
.margin_12 {
  margin: 12px;
}
.margin_8-left {
  margin-left: 8px;
  margin-top: 1px;
  margin-bottom: 1px;
  margin-right: 2px;
}
input {
  font-family: "Arial";
}
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
  margin: 0;
}
textarea:focus,
button:focus,
input:focus {
  outline: none;
}
.margin_div {
  height: 20px;
  background-color: #f5f5f5;
}
.content {
  margin: 0px;
  padding: 0px;
}
.main {
  max-width: 900px;
  min-width: 250px;
  text-align: left;
  margin: 0px;
  padding: 0px 10px 0px 10px;
  background-color: #ffffff;
}
.title_cbn {
  font-size: 18px;
  word-wrap: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.sil {
  text-decoration: none;
}
.colorgreen {
  color: #28862b;
}
.kart a {
  text-decoration: none;
  color: #000000;
}
.kart a:hover {
  text-decoration: none;
  color: #ff6600;
  cursor: pointer;
}
.kart {
  display: block;
  background-color: #ffffff;
  max-width: 100%;
  min-width: 200px;
  margin-top:10px;
  margin-bottom: 10px;
}
.margin_bottom_kart {
  width: 100%;
  padding: 0px 10px 0px 10px;
  background-color: #f5f5f5;
  height: 10px;
  margin-left: -10px;
}
.kart table {
  border-collapse: collapse;
}
.kart .data_time {
  font-size: 15px;
  color: #222;
  float: left;
  padding-top: 5px;
}
.kart .adress {
  font-size: 16px;
  color: #222;
}
.kart .sena {
  font-size: 17px;
  color: #333333;
}
.kart .opisanie {
  margin-top:5px;
  margin-bottom:5px;
  word-wrap: break-word;
  font-size: 16px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}
svg:hover {
  cursor: pointer;
}
.div_kart_img {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 153px;
  background-color: #f5f5f5;
  z-index: 30;
}
.kart_img {
  width: 100%;
  border-radius: 5px; /*8px 0px 0px 8px;*/
}
.iconvip span{
  padding:6px 10px 6px 10px;
  font-size: 14px;
  position: absolute;
  top: 5px;
  left: 5px;
  color: #ffffff;
  font-weight: bold;
  background-color: #1db781;
  border-radius: 5px;
  z-index: 100;
}
.icontop span{
  padding:5px 8px 5px 8px;
  font-size: 14px;
  position: absolute;
  top: 5px;
  left: 5px;
  color: #000000;
  font-weight: bold;
  background-color: #FBCD05;
  border-radius: 5px;
  z-index: 100;
}
.footer_podat{
  height:60px;
  left: 0px;
  bottom:0px;
  position: fixed;
  max-width:100%;
  min-width: 100%;
  background-color:#fff;
  z-index: 1001;
}
.footer_podat .main{
  margin:0 auto;
  max-width: 900px;
  min-width: 250px;
  padding-top:5px;
  border-top:1px solid #ccc;
}
.footer_podat .main button{
 text-align: center;
 width:200px;
}
/***** */
.custom-checkbox {
  z-index: -1;
  opacity: 0;
}
.custom-checkbox + label {
  display: inline-flex;
  align-items: left;
  user-select: none;
  font-size: 20px;
}
.custom-checkbox + label::before {
  content: "";
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid #0066ff;
  border-radius: 0.25em;
  margin-right: 0.2em;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}
.custom-checkbox:not(:disabled):not(:checked) + label:hover::before {
  border-color: #b3d7ff;
}
.custom-checkbox:not(:disabled):active + label::before {
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
.custom-checkbox:focus + label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-checkbox:focus:not(:checked) + label::before {
  border-color: #80bdff;
}
.custom-checkbox:checked + label::before {
  border-color: #0b76ef;
  background-color: #0b76ef;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
}
.custom-checkbox:disabled + label::before {
  background-color: #e9ecef;
}
/**     */
.custom-radio {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-radio + label {
  display: inline-flex;
  align-items: center;
  user-select: none;
}
.custom-radio + label::before {
  content: "";
  display: inline-block;
  width: 0.8em;
  height: 0.8em;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid #adb5bd;
  border-radius: 50%;
  margin-right: 0.4em;
  margin-top: -0.1em;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}
.custom-radio:not(:disabled):not(:checked) + label:hover::before {
  border-color: #b3d7ff;
}
.custom-radio:not(:disabled):active + label::before {
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}
.custom-radio:focus + label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-radio:focus:not(:checked) + label::before {
  border-color: #80bdff;
}
.custom-radio:checked + label::before {
  border-color: #0b76ef;
  background-color: #0b76ef;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.custom-radio:disabled + label::before {
  background-color: #e9ecef;
}
</style>
